// 消息通知管理
import http from "@/jslibs/axios/http";

// 消息通知列表
export const list = (data) => http.get("/v1/cms/message", data);

// 消息通知新增
export const add = (data) => http.post("/v1/cms/message", data);

// 消息通知编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/message/${uuid}`, data);

// 消息通知删除
export const del = (data) => http.delete(`/v1/cms/message/${data.cuuid}`);

// 消息通知详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/message/${cuuid}`, data);